// PANTALLA 3 — La Intensidad del Entrenamiento
// Documento Maestro v2.2, §2 (segunda pregunta) · pantalla propia desde el
// 24-09-2026.
//
// El valor elegido aquí (`training_intensity`) sustituyó al antiguo deadline
// cuando NSL dejó de prometer fechas de fluidez: en un gimnasio el alumno
// elige cuánto peso levanta, no cuándo termina.
//
// Vivía apilada debajo del detonante, en la pantalla 2, y aparecía al contestar
// la primera pregunta. Rob lo describió así: «esto debería ser otro paso,
// porque pone abajo y no me agrada». El problema de fondo es que la pregunta
// nacía fuera del área visible: el alumno veía aparecer el botón de continuar
// y se iba sin haberla leído, o peor, sin saber que estaba ahí.
import { useState } from 'react';
import OptionCards, { MicroReaction } from './OptionCards';
import { SCREEN2_INTENSITY_HEADLINE, TRAINING_INTENSITIES } from './onboardingContent';
import { etiquetaDePaso } from './pasos';

export default function Screen2_5_Intensidad({ intensity, onAnswer, onNext }) {
  const [selected, setSelected] = useState(intensity ?? null);

  const chosen = TRAINING_INTENSITIES.find((i) => i.value === selected);

  const handleSelect = (v) => {
    setSelected(v);
    onAnswer({ training_intensity: v });
  };

  return (
    <div className="ob-screen">
      <p className="ob-eyebrow">{etiquetaDePaso(3)}</p>
      <h1 className="ob-headline">
        <span className="ob-headline-linea">{SCREEN2_INTENSITY_HEADLINE.linea}</span>
        <span className="ob-bloque">{SCREEN2_INTENSITY_HEADLINE.bloque}</span>
      </h1>

      <OptionCards
        options={TRAINING_INTENSITIES}
        selected={selected}
        onSelect={handleSelect}
      />

      <MicroReaction text={chosen?.reaction} />

      {chosen && (
        <div className="ob-actions">
          <button type="button" className="ob-btn" onClick={onNext}>
            Continuar →
          </button>
        </div>
      )}
    </div>
  );
}
